<template>
  <div class="wrapper pa-4">
    <h1>js数组</h1>
    <p><a href="https://wangdoc.com/javascript/types/array">https://wangdoc.com/javascript/types/array</a></p>
  </div>
</template>

<script>

export default {
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

</style>